export default __webpack_public_path__ + "static/media/mm.6afc8d83.svg";